<template>
    <div id="builder">
      <div class="welcome-message">
        
        <div style="border: 1px solid #434857; border-radius: 6px; padding: 25px; margin-bottom: 1rem;" class="message-text">
          <h2 style="color: #1997c6; margin-bottom: 1rem">Welcome</h2>
          <p>This App might be a handy tool for people with basic knowledge of desktop systems.</p>
          <p>You can build a fully customized desktop, estimate its price, and make sure that all the parts are compatible with each other.</p>
          <p>(E.g. if Intel processor is chosen, the app will indicate a compatibility issue uncompatible parts.)</p>
          <p>To get started, use sidebar to navigate through the checklist. It is recommended to start with picking a Processor(CPU) and continue down the list.</p>
          <button @click="start()" style="width: 141px; margin-top: 18px; margin-bottom: 12px;" class="gc-button">Start Now</button>
        </div>
      </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'BuildHome',
  methods: {
    ...mapActions([
      'getLastRoute',
    ]),
    updateRoute(){
      this.getLastRoute(this.$route.path)
    },
    start(){
      this.$router.push('cpu').catch(()=>{})
    }
  },
}
</script>

<style scoped>
.welcome-message {
  display: inline-block;
  border-radius: 6px;
  padding: 15px;
  text-align: center;
  font-size: 12pt;
  padding-bottom: 25px;
}
@media (max-width: 1200px) {
  .welcome-message {
    margin-top: 10px;
    margin-left: -5px;
    margin-right: 28px;
  }
}
</style>